import { PutCases } from "../api/index";
import { GetEngineerCasesById } from "../api/viewgres_v4";
import { ShowApiError } from "@/request/error";
import form from "../mixins/form";
export default {
  mixins: [form],
  methods: {
    updateByVgcId(row) {
      if (row.vgc_engineering_case_id == null) {
        this.$message.error("请先绑定唯格云案例");
        return;
      }

      this.$msgbox({
        title: "提示",
        message: `是否确定将[${row.name.cn}]与唯格云案例同步?`,
        showCancelButton: true,
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
        beforeClose: async (action, instance, done) => {
          if (action === "confirm") {
            try {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "开始同步...";
              const { data } = await GetEngineerCasesById(
                row.vgc_engineering_case_id
              );
              instance.confirmButtonText = "正在构建表单...";
              let formData = this.buildFormByVgcData(data);
              formData.seq = row.seq;
              instance.confirmButtonText = "正在覆盖数据...";
              await PutCases([
                {
                  id: row.id,
                  ...formData
                }
              ]);
              instance.confirmButtonLoading = false;
              instance.confirmButtonText = "同步完成";
              this.$message.success("同步完成");
              done();
            } catch (error) {
              ShowApiError("同步失败", error);
              done();
              return;
            } finally {
              instance.confirmButtonLoading = false;
              instance.confirmButtonText = "确 定";
            }
          } else {
            done();
          }
        }
      }).catch(() => {
        this.$message({
          type: "info",
          message: "取消"
        });
      });
    }
  }
};
